import styled, { css } from "styled-components";

export default function BIMClassCard(props) {
    const { id, name, type, ...restProps } = props;

    return (
        <Styled
            as={ props.onClick ? "button" : "div" }
            { ...restProps }
        >
            <span className="name">{ name }</span>
            <span className="type">{ type }</span>
        </Styled>
    );
}

const Styled = styled.button`
    align-items: flex-start;
    background: transparent;
    color: #000;
    border: 1px solid transparent;
    border-radius: 2px;
    cursor: default;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 24px 8px 16px;
    text-align: left;
    transition: 200ms;

    .name {
        font-size: 3.2em;
        font-family: var(--font-mono), monospace;
        letter-spacing: -.04em;
    }

    .type {
        font-size: 1em;
        font-family: var(--font-mono), monospace;
        user-select: none;

        &::after {
            content: "]";
        }

        &::before {
            content: " [";
        }

        &:empty {
            display: none;
        }
    }

    ${ ({ onClick }) => onClick && CSSClickable }
`;

const CSSClickable = css`
    cursor: pointer;

    &:hover {
        .name {
            text-decoration: underline;
        }
    }
`;
